
export default "/assets/x-mark-micro.1f668560.svg"